import React, { useState, useRef } from 'react';
import { Grid, Box, Autocomplete, TextField, Chip, Typography, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';

const SourceOfKnowledgeField = ({ contentData, setContentData, showIcons, setShowIcons }: any) => {
    const [selectedSources, setSelectedSources] = useState<string[]>(Array.isArray(contentData.sourceOfKnowledge) ? contentData.sourceOfKnowledge : []);
    const sources = ['Scientific Research', 'Clinical Insights', 'Lived Experience', 'Expert Opinion', 'Case Studies'];
    const autoCompleteRef = useRef<any>(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);


    const handleSourceChange = (event: any, newValue: string[]) => {
        // Ensure newValue is an array before updating
        if (Array.isArray(newValue)) {
            setSelectedSources(newValue);
            // Update contentData with the new categories
            setContentData((prevContentData: any) => ({
                ...prevContentData,
                sourceOfKnowledge: newValue, // Assuming 'category' is a field in contentData
            }));
            // Update showIcons visibility immediately
            setShowIcons((prevState: any) => ({
                ...prevState,
                sourceofknowledge: newValue.length > 0,
            }));
        }
    };

    const handleDelete = (option: string) => {
        const updatedSources = selectedSources.filter((source) => source !== option);
        setSelectedSources(updatedSources);
        // Update contentData when a category is deleted
        setContentData((prevContentData: any) => ({
            ...prevContentData,
            sourceOfKnowledge: updatedSources,
        }));
        // Update showIcons based on the remaining sources
        setShowIcons((prevState: any) => ({
            ...prevState,
            sourceofknowledge: updatedSources.length > 0, // Hide icon if no sources are left
        }));
    };

    const handleExpandClick = () => {
        setDropdownOpen((prevOpen) => !prevOpen);
    };

    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} display={"flex"} gap={1} flexDirection={"column"}>
                <label
                    htmlFor="source-input"
                    style={{
                        fontWeight: 700, fontSize: "18px", color: "#000000",
                    }}
                >
                    Please Make a Selection
                    <span style={{ fontWeight: 400, fontSize: "17px", color: "#797979", }}>{` (You can select multiple sources)`}</span>
                </label>
                <Box sx={{ flexGrow: 1, mb: 2 }}>
                    <Autocomplete
                        multiple
                        id="source-input"
                        options={sources}
                        value={selectedSources}
                        onChange={handleSourceChange}
                        ref={autoCompleteRef}
                        open={dropdownOpen} // Controlled open state
                        onOpen={() => setDropdownOpen(true)} // Open on focus
                        onClose={() => setDropdownOpen(false)} // Close on blur
                        renderTags={() => null}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"

                                placeholder="Select sources"
                                InputProps={{
                                    ...params.InputProps,
                                    sx: {
                                        width: { xs: "333px", md: '654px' },
                                        // height: "50px",
                                        borderRadius: "9px",
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderRadius: "9px",

                                        },
                                        display: 'flex',
                                        alignItems: 'center',

                                    },
                                    endAdornment: (
                                        <IconButton edge="end" onClick={handleExpandClick}>
                                            <ExpandMoreIcon />
                                        </IconButton>
                                    ),
                                }}
                                inputProps={{
                                    ...params.inputProps,
                                    style: {
                                        paddingLeft: '10px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        height: '100%',
                                    },
                                }}
                            />
                        )}
                    />
                </Box>
                <Box display="flex" gap={1} flexWrap="wrap" mt={10}>
                    {selectedSources.map((option, index) => (
                        <Chip
                            key={option}
                            label={option}
                            onDelete={() => handleDelete(option)}
                            deleteIcon={<CloseIcon />}
                            sx={styleSheet.selectedOptCon}
                        />
                    ))}
                </Box>
            </Grid>
        </Grid>
    );
};

export default SourceOfKnowledgeField;

const styleSheet = {
    selectedOptCon: {
        margin: '4px', fontSize: "20px",
        color: "#595959",
        fontWeight: 400,
        width: "223px",
        background: "#E8E8E8",
        height: "50px",
        borderRadius: "9px",
        border: "1px solid #BFBFBF"
    }
} 